
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Mask Group 1","transform":"translate(-8927.066 289.883)","clip-path":"url(#clip-path)"}},[_c('g',{attrs:{"data-name":"facebook (6)","transform":"translate(8927.066 -289.883)"}},[_c('circle',{attrs:{"data-name":"Ellipse 1532","cx":"30","cy":"30","r":"30","fill":"#3b5998"}}),_c('path',{attrs:{"data-name":"Path 1691","d":"M37.542 31.174h-5.353v19.612h-8.11V31.174h-3.858v-6.892h3.857v-4.46c0-3.189 1.515-8.184 8.183-8.184l6.008.025v6.69H33.91a1.651 1.651 0 00-1.72 1.879v4.056h6.061z","fill":"#fff"}})])])])
          )
        }
      }
    